module.exports = __webpack_public_path__ + "img/cert4.db8da1bd.jpg";